import {
  Flex,
  FormDateTimeInput,
  FormNumberInput,
  FormRadioSelection,
  Grid,
  Text,
} from '@shared/components';
import { dayjs } from '@shared/utils';

import { EventEndType } from '../../providers';

export interface RegistrationPeriodFormFieldProps {
  slotProps: {
    eventEndDate: {
      type?: EventEndType;
      errorMessage?: string;
      examRecurringStartDate?: Date | null;
    };
    examDateGroup: {
      minDate: Date;
      maxDate: Date;
    };
  };
}

export default function RegistrationPeriodFormField(
  props: Readonly<RegistrationPeriodFormFieldProps>,
) {
  const { slotProps } = props;

  const minEventStartDate = dayjs.max(
    dayjs().add(1, 'day'),
    dayjs(slotProps.examDateGroup.minDate).startOf('month'),
  );

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
      <Grid
        sx={(theme) => ({
          columnGap: theme.spacing(6),
          rowGap: theme.spacing(6),
          gridTemplateColumns: '240px 1fr',
        })}
      >
        <Text variant='body1Semibold'>วันที่เปิด-ปิดรับสมัคร</Text>
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
          <FormDateTimeInput
            name='eventStartDate'
            label='วันที่เปิดรับสมัคร'
            inputFormat='DD-MM-YYYY'
            placeholder='DD-MM-YYYY'
            initialMonth={slotProps.examDateGroup.minDate}
            minDate={minEventStartDate.toDate()}
            maxDate={slotProps.examDateGroup.maxDate ?? undefined}
            rules={{
              required: true,
            }}
            defaultTime={{
              hour: 0,
              minute: 0,
              second: 0,
            }}
          />
          <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(1) }}>
            <FormRadioSelection
              name='eventEndDate.type'
              label='วันที่ปิดรับสมัคร'
              required
              options={[
                {
                  label: 'ปิดรับสมัครวันสอบ - ระบบจะปิดรับสมัครอัตโนมัติ 30 นาทีก่อนเวลาเริ่มสอบ',
                  value: EventEndType.ON_EXAM_DATE,
                },
                {
                  label: (
                    <Flex
                      sx={{
                        alignItems: 'center',
                        gap: (theme) => theme.spacing(2),
                        flexWrap: 'nowrap',
                      }}
                    >
                      <Text sx={{ flexShrink: 0 }}>ปิดรับสมัครล่วงหน้า</Text>
                      <FormNumberInput
                        name='eventEndDate.date'
                        disabled={slotProps.eventEndDate.type !== EventEndType.BEFORE_EXAM_DATE}
                        sx={{ maxWidth: '80px' }}
                        slotProps={{ htmlInput: { sx: { textAlign: 'center' } } }}
                      />
                      <Text sx={{ flexShrink: 0 }}>วัน (เวลาปิดรับสมัคร: 23:59 น.)</Text>
                    </Flex>
                  ),
                  value: EventEndType.BEFORE_EXAM_DATE,
                },
              ]}
            />
            {slotProps.eventEndDate.errorMessage ? (
              <Text
                variant='caption'
                sx={(theme) => ({
                  color: theme.palette.error.main,
                })}
              >
                {slotProps.eventEndDate.errorMessage}
              </Text>
            ) : null}
          </Flex>
        </Flex>
      </Grid>
    </Flex>
  );
}
